
import Hero from './EntryPage';
import {useState} from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useGenericEffect } from '../components/UseGenericEffect';
import UnderConstruction from '../components/UnderConstruction';


export default function About() {
  const { strings } = useLanguage();
  const map = {
  };  
  const [message, setMessage] = useState('');
  return (
    <div className="main">
       <UnderConstruction />   
    </div>
  );
}
